import { HTMLAttributes, PropsWithChildren, ReactNode } from 'react';
import { Typography } from '@ghq-abi/design-system-v2';

type CardHeader = PropsWithChildren<HTMLAttributes<HTMLDivElement>> & {
  description?: ReactNode;
};

export function Header({
  children,
  description,
  className,
  ...rest
}: CardHeader) {
  return (
    <div className={`p-4 flex-col flex gap-1 ${className || ''}`} {...rest}>
      <Typography
        as="h2"
        variant="body-sm-bold"
        className="text-[var(--theme-color-text-dark)]">
        {children}
      </Typography>

      {description && (
        <>
          {typeof description === 'string' ? (
            <Typography as="p" variant="body-sm-regular">
              {description}
            </Typography>
          ) : (
            description
          )}
        </>
      )}
    </div>
  );
}
